<template>
  <b-modal ref="modal" hide-footer no-close-on-backdrop hide-header-close>
    <template #modal-title>
      <span>
        {{ labels.title }}
      </span>
    </template>
    <div class="d-block pb-2">
      <b-alert show variant="warning" class="mb-2 send-survey-warning">
        <i class="material-icons">warning</i> {{ labels.alert }}
      </b-alert>
      <div class="form-group send-to-company">
        <div class="send-to-company-switch">
          <Switches
            type-bold="true"
            theme="custom"
            color="primary"
            :value="managersPermission"
            @input="changeSurveyAccessProperty($event, 'managersPermission')"
          />
        </div>
        <span class="send-to-company-label">
          {{ labels.manager }}
        </span>
      </div>
      <div v-if="isAdmin">
        <hr />
        <b-alert show variant="warning" class="mb-2 send-survey-warning">
          <i class="material-icons">warning</i> {{ labels.managerAlert }}
        </b-alert>
        <b-container fluid class="public-form">
          <b-row>
            <b-col>
              <div class="form-group">
                <span class="label">{{ labels.user }}</span>
                <v-select
                  multiple
                  :value="users"
                  :options="usersOpt"
                  :closeOnSelect="true"
                  :filterable="false"
                  @search="$emit('searchForManagers', $event)"
                  @input="changeSurveyAccessProperty($event, 'users')"
                >
                  <template slot="option" slot-scope="option">
                    <div>
                      {{
                        `${option.profile.firstname} ${option.profile.lastname}`
                      }}
                    </div>
                  </template>

                  <template slot="no-options">
                    {{ labels.search }}
                  </template>

                  <template slot="selected-option" slot-scope="option">
                    <div class="tag-wrap" :title="option.email">
                      <span class="tag-image mdi mdi-account"></span>
                      <span class="tag-label">
                        {{
                          `${option.profile.firstname} ${option.profile.lastname}`
                        }}
                      </span>
                    </div>
                  </template>
                </v-select>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <hr />
    <div class="footer pt-2">
      <b-button
        variant="primary"
        class="float-right text-transform-none modal-btn"
        size="lg"
        @click="hide()"
      >
        {{ labels.close }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Switches from 'vue-switches'
import vSelect from 'vue-select'
import { isAdmin } from '@/service/user'

const props = {
  managersPermission: {
    type: Boolean,
  },
  users: {
    type: Array,
  },
  usersOptions: {
    type: Array,
  },
}

export default {
  props,
  components: {
    Switches,
    vSelect,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.customSurveys.create.modals.access
    },
    usersOpt: function() {
      return this.normalizeLabel(this.usersOptions)
    },
    isAdmin() {
      return isAdmin()
    },
  },
  methods: {
    normalizeLabel(collection = []) {
      return collection.map(item =>
        Object.assign(item, {
          id: `${item.id || item._id}`,
          label: `${item.id || item._id}`,
        })
      )
    },
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    changeSurveyAccessProperty(value, property) {
      this.$emit('changeSurveyAccessProperty', { property, value })
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.public-form {
  .v-select .vs__dropdown-toggle .vs__selected {
    border-radius: 10px !important;
  }

  .v-select .vs__dropdown-toggle {
    border-radius: 10px !important;
    background-color: map-get($theme-colors, 'white') !important;
    border-color: var(--gray07) !important;
  }

  .readonly-input .vs__dropdown-toggle {
    border-color: map-get($theme-colors, 'white') !important;
  }
}
</style>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.send-to-company {
  display: flex;
  margin-bottom: 2rem !important;
  color: map-get($theme-colors, 'primary');
  font-size: 14px;

  .send-to-company-label {
    margin-left: 0.5rem !important;
  }
  .vue-switcher {
    margin-bottom: -1rem !important;
  }
}

.public-form {
  .form-group {
    margin-top: 0rem !important;

    .label {
      margin-left: 20px;
      color: #32132e;
      font-size: 12px;
    }
  }
}

.modal-btn {
  border-radius: 10px !important;
  min-width: 160px;
}

.send-survey-warning {
  border-radius: 10px !important;
  border-color: var(--gray07) !important;
  font-size: 14px !important;
}
</style>
